module.exports = __webpack_public_path__ + "static/media/Calzados.39c95926.jpeg";